/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateSearchRequest
 */
export interface CreateSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSearchRequest
     */
    query?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSearchRequest
     */
    fieldId?: number;
}

/**
 * Check if a given object implements the CreateSearchRequest interface.
 */
export function instanceOfCreateSearchRequest(value: object): boolean {
    return true;
}

export function CreateSearchRequestFromJSON(json: any): CreateSearchRequest {
    return CreateSearchRequestFromJSONTyped(json, false);
}

export function CreateSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'query': json['query'] == null ? undefined : json['query'],
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
    };
}

export function CreateSearchRequestToJSON(value?: CreateSearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'query': value['query'],
        'fieldId': value['fieldId'],
    };
}

